import styled, { css } from 'styled-components'
import { darken } from 'polished'

export const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 0;
`
export const PageDetails = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${props => props.theme.colors.lightDark};
`
export const PageButtonsContainer = styled.div`
  display: flex;
  align-items: center;
`
export const PageButton = styled.div`
  cursor: pointer;
  width: 24px;
  height: 24px;
  ${props => props.theme?.isLightMode ? css`
    background: #1D66E0;
  ` : css`
    background: linear-gradient(180deg, #F02FC2 0%, #1F66E0 100%);
  `}
  border-radius: 10px 0px 0px 10px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${props => props.theme?.isLightMode && css`
    svg {
      path {
        fill: #FFF;
      }
    }
  `}

  &:hover {
    ${props => props.theme?.isLightMode ? css`
      background: ${() => darken(0.04, '#1D66E0')};
    ` : css`
      background: linear-gradient(180deg, ${darken(0.04, '#F02FC2')} 0%, ${darken(0.04, '#1F66E0')} 100%);
    `}
  }
  &:active {
    ${props => props.theme?.isLightMode ? css`
      background: ${() => darken(0.1, '#1D66E0')};
    ` : css`
      background: linear-gradient(180deg, ${darken(0.1, '#F02FC2')} 0%, ${darken(0.1, '#1F66E0')} 100%);
    `}
  }
  ${({ isNext }) => isNext && css`
    ${props => props.theme?.isLightMode ? css`
      background: #1D66E0;
    ` : css`
      background: linear-gradient(180deg, #F02FC2 0%, #1F66E0 100%);
    `}
    border-radius: 0px 10px 10px 0px;
  `}

  ${({ disabled }) => disabled && css`
    cursor: not-allowed;
    opacity: 0.5;
    pointer-events: none;
  `}
`
export const CurrentPageNumber = styled.div`
  position: relative;
  > span {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 24px;
    min-width: 37px;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: ${props => props.theme.colors.lightDark};
    ${props => !props.theme?.isLightMode ? css`
      background: linear-gradient(270deg, rgba(233, 49, 195, 0.1) 0%, rgba(42, 99, 222, 0.1) 100%);
    ` : css`
      border: 1px solid rgba(29, 102, 224, 0.3); 
    `}
  }
  ${props => !props.theme?.isLightMode && css`
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      padding: 1px;
      background:linear-gradient(45deg, blue, #E931C3); 
      -webkit-mask: 
        linear-gradient(#fff 0 0) content-box, 
        linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
              mask-composite: exclude; 
    }
  `}
`
